'use strict';
namespace TR {

    interface Attraction {
        Details: AttractionDetails;
    }

    interface AttractionDetails {
        AttractionRequests: AttractionRequestMap;
    }

    interface AttractionRequestMap {
        [ProductId: string] : {Adult: number, Child: number, Infant: number};
    }

    interface AttractionModel {
        CaptureDate: boolean;
        PreferredDate: Date;
        ProductDescription: string;
        ProductId: string;
        ProductTitle: string;
    }

    class AttractionSelection {

        private attractions: Attraction[];
        private bookingLoaded: boolean;

        public model: AttractionModel[];
        public productPeopleCountMap: AttractionRequestMap = {};
        public dateCaptureRequired: boolean;
        public show: boolean;

        constructor(private $scope: ng.IScope)
        {
            const wait = $scope.$watch('as.bookingLoaded', b => {
                if(b) {
                    this.init();
                    wait();
                }
            });
        }

        private init() {

            if (this.attractions.length > 0) {
                this.show = true;

                //set up map of product Id and number of tickets per passenger type
                _.each(this.attractions, (a) => {_.assign(this.productPeopleCountMap, a.Details.AttractionRequests);});

                this.dateCaptureRequired = _.some(this.model, {'CaptureDate': true, 'PreferredDate' : !null });
            }
        }

    }

    angular
        .module('TR')
        .directive('attractionSelection', () => {
            return {
                bindToController: true,
                controller: AttractionSelection,
                controllerAs: 'as',
                restrict: 'E',
                replace: true,
                scope: {
                    bookingLoaded: '=',
                    attractions: '=',
                    maxDate: '=',
                    minDate: '=',
                    model: '=',
                    rootForm: '=',
                },
                templateUrl: (element,attr) => {
                    if(attr.templateVersion) {
                        return 'partials/booking/template?name=AttractionSelection&version='
                        + attr.templateVersion;
                    } else {
                        return 'partials/home/directivetemplate?type=AttractionSelection';
                    }
                }
            };
        });
};
